import { translate } from '../../../utils/GameEngine';
import { IconButton } from './IconButton';
import { AvatarManager } from '../../../core/managers/AvatarManager';
import { Avatar } from '../Avatar';

export class PlayWithFriendButton extends IconButton {
    private avatar: Avatar;

    constructor(callback?: () => any) {
        super(translate('Play\nwith a friend', true), callback, 'blue_btn_large@2x', true, true, 1, 64);
    }

    protected initProperties(): void {
        super.initProperties();
        this.iconTexture = 'share_icon@2x';
        this.iconScale = 0.4;
        this.labelStyle.fill = 0xFFFFFF;
        this.labelStyle.wordWrap = false;
    }

    protected drawLayout(): void {
        super.drawLayout();
        this.icon.visible = false;
        this.avatar = AvatarManager.getInstance().getEmptyAvatar();
        if (this.avatar) {
            this.addChild(this.avatar);
            this.avatar.scale.set(0.8, 0.8);
            this.avatar.y = this.defaultSkin.height / 2;
        }
    }

    public updateLabel(text: string): void {
        super.updateLabel(text);
        this.label.x += 16;
        this.label.y -= 3;
    }

    public getFriendID(): string {
        let result: string = null;
        if (this.avatar) {
            result = this.avatar.playerID;
        }
        return result;
    }
}